import { useFormat } from '@ideavivat/vivat-2';
import { bom_item } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    bom_item: {
      ...bom_item,
      name: 'Sub Job',
    },
    material: {
      name: 'รหัสชิ้นส่วน',
      width: '10rem',
      filter: (val: string, row: any) => row.item.material?.code || '',
    },
    _materialControls: {
      name: 'ชิ้นส่วน',
      width: '20rem',
      class: {
        cell: 'has-multiselect',
      },
    },
    neededAmount: {
      name: 'จำนวนที่เปิดใบสั่งซื้อ / ซื้อแล้ว',
      width: '12rem',
      class: 'text-right',
    },
    amount: {
      name: 'จำนวนที่แก้ไข',
      width: '8rem',
      class: 'text-right',
    },
    purchaseUnit: {
      name: 'หน่วยสั่งซื้อ',
      width: '6rem',
      class: 'text-right',
    },
    pricePerUnit: {
      name: 'ราคาต่อหน่วย',
      width: '6rem',
      class: 'text-right',
    },
    amountPerUnit: {
      name: 'จำนวนในกล่อง/แพ็ค',
      width: '10rem',
      class: 'text-right',
    },
    totalPrice: {
      name: 'รวมยอด',
      width: '6rem',
      filter: (val: string, row: any) => parseFloat(`${row.item.amount * row.item.pricePerUnit}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      class: 'text-right',
    },
    totalItems: {
      name: 'จำนวนที่ได้รับ',
      width: '6rem',
      filter: (val: string, row: any) => `${parseFloat(`${row.item.amount * row.item.amountPerUnit}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${row.item?.material?.unit || ''}`,
      class: 'text-right',
    },
    target_date: {
      name: 'วันที่ต้องการ',
      width: '10rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
  },
};
